import { render, staticRenderFns } from "./topBox.vue?vue&type=template&id=dbb71944&scoped=true"
import script from "./topBox.vue?vue&type=script&lang=js"
export * from "./topBox.vue?vue&type=script&lang=js"
import style0 from "./topBox.vue?vue&type=style&index=0&id=dbb71944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb71944",
  null
  
)

export default component.exports